const supportTicketMessageMetadataSectionStart =
  /\n\n?---\n(?:Przedmiot zgłoszenia:|Produkty:|Faktura:)/;

export function stripSupportTicketMessageMetadata(messageBody: string): string {
  const match = messageBody.match(supportTicketMessageMetadataSectionStart);
  if (!match || match.index === undefined) return messageBody;
  return messageBody.slice(0, match.index).trimEnd();
}
